module.exports = __webpack_public_path__ + "static/media/tour-0.8bbb9bec.png";